const types = {
  GET_STATUSES_START: 'GET_STATUSES_START',
  GET_STATUSES_SUCCESS: 'GET_STATUSES_SUCCESS',
  GET_STATUSES_ERROR: 'GET_STATUSES_ERROR',
  SAVE_STATUSES_START: 'SAVE_STATUSES_START',
  SAVE_STATUSES_SUCCESS: 'SAVE_STATUSES_SUCCESS',
  SAVE_STATUSES_ERROR: 'SAVE_STATUSES_ERROR',
};
export default types;
